module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-layout"
  }, [_c('main-header'), _vm._v(" "), _c('div', {
    staticClass: "dashboard-layout-view"
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43e4d833"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/DashboardLayout.vue
// module id = 1303
// module chunks = 1